module.exports = __webpack_public_path__ + "img/linkedin.16f8fcac.svg";